export default function PrivacyPolicy() {
  return (
    <div className="container mx-auto max-w-4xl px-4 py-8">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p>
        At Uptime Monitor, we value the privacy and security of our users. This Privacy Policy
        outlines the types of information we collect, how we use and protect that information, and
        the choices you have regarding your personal data.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">Information We Collect:</h2>
      <ul className="list-disc list-inside">
        <li>
          Personal Information: When you sign up for our services, we collect personal information
          such as your name, email address, and/or contact details.
        </li>
        <li>
          Website and Server Data: We may collect data related to your websites and servers,
          including URLs, IP addresses, response times, and uptime/downtime information.
        </li>
        <li>
          Log Data: Our servers automatically collect log data, which may include your IP address,
          browser type, and access times.
        </li>
      </ul>

      <h2 className="text-xl font-bold mt-6 mb-2">Use of Information:</h2>
      <ul className="list-disc list-inside">
        <li>
          To provide and maintain our services, including monitoring the uptime of your websites and
          servers.
        </li>
        <li>
          To send you important notifications, service updates, and account-related communications.
        </li>
        <li>
          To improve our services, develop new features, and conduct data analysis for internal
          purposes.
        </li>
        <li>
          To comply with legal obligations and protect our rights and the rights of our users.
        </li>
      </ul>

      <h2 className="text-xl font-bold mt-6 mb-2">Data Security:</h2>
      <p>
        We take appropriate measures to protect the security of your personal information and
        prevent unauthorized access, use, or disclosure.
      </p>
      <p>We use industry-standard encryption protocols to transmit sensitive data.</p>
      <p>
        While we strive to protect your information, no method of transmission over the internet or
        electronic storage is 100% secure.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">Data Retention:</h2>
      <p>
        We retain your personal data for as long as necessary to fulfill the purposes outlined in
        this Privacy Policy, unless a longer retention period is required by law.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">Third-Party Services:</h2>
      <p>
        We may use third-party service providers to assist us in delivering our services and to
        analyze usage patterns. These providers have access to certain information but are obligated
        to maintain its confidentiality.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">Your Rights:</h2>
      <p>
        You have the right to access, modify, or delete your personal information. You can manage
        your account settings or contact us for assistance.
      </p>
      <p>
        You may choose to unsubscribe from our marketing communications at any time by following the
        instructions provided in the emails.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">Changes to this Privacy Policy:</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of any significant
        changes by posting the updated version on our website or through other communication
        channels.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">Contact Us:</h2>
      <p>
        If you have any questions, concerns, or requests regarding this Privacy Policy or our data
        practices, please contact us at{" "}
        <a href="mailto:support@uptime-monitor.io">support@uptime-monitor.io</a>.
      </p>
      <p>This Privacy Policy was last updated on 06/18/2023.</p>
    </div>
  );
}
